import { Component, EventEmitter, Input, OnInit, Output, NgModule, Inject, AfterViewInit } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { Router } from '@angular/router';
import { CASINO_LOBBY_GAMES } from '@environments/environment';

@Component({
  selector: 'casinolobby-component',
  templateUrl: '../sharedTemplates/casinolobby-component.html',
})
export class CasinoLobby implements AfterViewInit {
  casinoList = [];

  selectedCasinoType = 0;

  gameTypes = CASINO_LOBBY_GAMES;

  constructor(
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router
  ) {}

  goGames(item) {
    this._router.navigate([item.path]);
  }

  ngAfterViewInit() {
    if (this._UiHelper.leftMenu) this._UiHelper.setLeftMenu();

    this._UiHelper.setNavbarTitle('Casino', true);
  }
}
